export default {
  RequirementObj: {
    PROPERTY_MANAGEMENT: '物业管理平台',
    INTELLECTUAL_PROPERTY: '智慧物联平台',
    PROPERTY_REGULATION: '物业监管平台',
    PROPERTY_ELECTRICITY: '物业电商平台',
  },
  NewsPartObj: {
    POLICY: '政策法规',
    INDUSTRY_NEWS: '行业资讯',
    COMPANY_NEWS: '企业新闻',
  },
  screenPageStateObj: {
    '': '全部',
    'PLAYING': '播放中',
    'STOP_PLAY': '已停播',
  },
  projectManageState: {
    NOT_VERIFIED: '未认证',
    VERIFYING: '审核中',
    REJECT: '已驳回',
    VERIFIED: '已认证',
  },
  projectManage: {
    WRZ: '未认证',
    YRZ: '已认证',
    VERIFYING: '审核中',
    REJECT: '已驳回',
  },
  AuthorizeStatusObj: {
    AUDITING: '待审核',
    AUTHORIZED: '已通过',
    FAIL: '已拒绝',
  },
  ResourceTypeStatus: {
    ACS_DEVICE: '门禁控制器',
    CAMERA: '监控点',
  },
  AcsTypeStatus: {
    VILLAGE_GATE: '小区大门',
    UNIT_GATE: '单元门',
  },
  EquipmentStatus: {
    OFFLINE: '离线',
    ONLINE: '在线',
  },
  propertyCheckTaskStatus: {
    NO_START: '未开始',
    PROCESSING: '进行中',
    FINISH: '已完成',
    INVALID: '作废',
  },
  // 物业检查状态
  propertyCheckStatus: {
    NO_START: '未开始',
    PROCESSING: '进行中',
    STOP: '已终止',
  },
  // 物业检查方式
  propertyCheckWay: {
    AUTO: '自动发布',
    HAND: '手动发布',
  },
  // 店铺认证状态
  VerifyStateObj: {
    NOT_VERIFIED: '未认证',
    VERIFYING: '审核中',
    REJECT: '已驳回',
    VERIFIED: '已认证',
    WAIT_VERIFY: '待审核',
    CANCEL: '已取消',
  },

  // 物业层高
  PropertyHeightObj: {
    LESS_TEN: '10层以下',
    TEN_TO_TWENTY: '10层至20层',
    MORE_TWENTY: '20层以上',
  },

  // 物业类型
  PropertyTypeObj: {
    RESIDENCE: '商品房',
    VILLA: '拆迁安置房',
    OFFICES: '保障性住房',
    HOSPITAL: '集资建房',
    SCHOOL: '农村集中住宅区',
    BUSINESS: '商业非住宅',
    // INDUSTRIAL: '工业',
    // STATION: '车站',
    // PARK: '公园',
    // OTHER: '其他'
  },
  // 管理现状

  // 设施设备状态
  EquipmentStatusObj: {
    NORMAL: '正常',
    BREAK_DOWN: '故障',
  },

  // 附属共有关系
  AffiliationObj: {
    AREA: '区划内共有',
    BUILDING: '楼栋共有',
    UNIT: '单元共有',
  },

  // 审批子状态
  FlowSubStateType: {
    WAIT: '待审批',
    PASS: '已通过',
    REJECT: '已驳回',
    CANCEL: '已撤销',
    INIT: '待审批',
  },
  // 审批子状态
  FlowSubStateObj: {
    PASS: '同意',
    REJECT: '驳回',
    CANCEL: '撤销',
    WAIT: '',
    INIT: '',
  },

  // 审核状态
  AuditStatusObj: {
    WAIT_AUDIT: '待审核',
    PASSED: '已通过',
    REJECTED: '已驳回',
  },

  // 审批状态
  ApprovalStateObj: {
    APPROVAL_BEING: '审批中',
    APPROVAL_PASSED: '已通过',
    APPROVAL_REJECT: '已驳回',
    APPROVAL_UNDO: '已撤销',
  },

  // 电子投票
  voteState: {
    WKS: '未开始',
    JXZ: '进行中',
    YJZ: '已结束',
    YZZ: '已终止',
  },
  // 电子投票
  voteResultType: {
    VALID: '有效',
    INVALID: '无效',
  },
  // 支付方式
  WayOfInOutTypeObj: {
    WEIXIN: '微信',
    ALIPAY: '支付宝',
    BANK: '银行',
    CASH: '现金',
    OTHER: '其他',
  },

  // 一级分类
  JmhBillTypeObj: {
    RECEIVE_PAYMENT: '收款',
    PAYMENT: '付款',
    REFUND: '退款',
  },

  // 通讯审核状态
  COMMUNICATIONSTATE: {
    DSH: '待审核',
    WTG: '已驳回',
    YTG: '已通过',
    // YQX: '已取消'
  },
  // 身份类型
  IdTypeObj: {
    ID_CARD: '身份证',
    PASSPORT: '护照',
  },

  // 变更类型
  ChangeTypeObj: {
    OWNER_BIND: '户主绑定',
    OWNER_UNBIND: '取消绑定',
    OWNER_CHANGE: '变更业主',
  },
  // 房屋状态
  HouseStatusObj: {
    IS_NOT_SALE: '未出售',
    IS_SALE: '已出售',
  },
  // 使用状态
  StayStatusObj: {
    IS_NOT_STAY: '未入住',
    YZ_STAY: '业主入住',
    ZK_STAY: '租客入住',
  },
  // 使用状态 未出售
  StayStatusObjOFF: {
    IS_NOT_STAY: '未入住',
  },

  // 证件类型
  CARDTYPE: {
    ID_CARD: '身份证',
    PASSPORT: '护照',
  },
  // 物业类型
  VILLAGETYPE: {
    ZZXQ: '商品房',
    GY: '公有售房',
    XZL: '新居工程',
    CQAZF: '拆迁安置房',
    DYCQR: '单一产权人',
    TGZJF: '统规自建房',
    ZDCQF: '征地拆迁房',
    SYFZZ: '商业非住宅',
    QTFZZ: '其他非住宅',
    BZXZF: '保障性住房',
    QEJZJF: '全额集资建房',
    NCJZJZQ: '农村集中居住区',
  },
  // 应用分类
  QUICKENTRY: {
    CHARGE: '收费管理',
    SERVICE: '服务管控',
    OA: 'OA系统',
    ORDER: '我的订单',
    FINANCIAL: '财务管理',
    BASE: '基础物业',
    SMART: '智慧物业',
    VILLAGE_MANAGER: '小区管理',
    PROJECT_INFO: '项目信息',
  },
  // 巡检管理
  XJGL: {
    ABLE: '启用',
    DISABLE: '禁用',
    0: '每年',
    1: '每季度',
    2: '每月',
    3: '每周',
    4: '每天',
    NO_START: '未开始',
    PROCESSING: '进行中',
    STOP: '已终止',
    END: '已结束',
    未开始: 'NO_START',
    进行中: 'PROCESSING',
    已终止: 'STOP',
    已结束: 'END',
  },
  // 商品分类
  SPFL: {
    SHOW: '待处理',
    PROCESSING: '处理中',
  },
  // 权限组
  GROUP: {
    PLATFORM: '平台',
    COMPANY: '服务商',
    VILLAGE: '小区',
    PROPERTY: '物业（废弃）',
    COMMITTEE: '业主大会',
    POLITICS: '社区',
  },
  ROLETYPE: {
    ADMIN: '超级管理员',
    PLATFORM: '平台普通角色',
    SUB_ADMIN: '子站管理员',
    SUB_NORMAL: '子站普通角色',
    SUPERVISION: '监管角色',
  },
  // 巡检任务&巡更任务 一级状态
  TaskStatusObj: {
    NO_START: '未开始',
    REVIEWING: '审核中',
    PROCESSING: '进行中',
    UNCOMPLETED: '未完成',
    OVERTIME: '已超时',
    DELAYREVIEW: '延期待审核',
    END: '已结束',
    COMPLETED: '已完成',
    STOP: '已终止',
    TRANSFER: '已转移',
    CLOSED: '已关闭',
    CANCEL: '已撤销',
    CLEAR: '清除',
    NOT_ASSIGNED: '未指派',
  },
  // 查询条件
  TaskStatusQueryObj: {
    NOT_ASSIGNED: '未指派',
    NO_START: '未开始',
    PROCESSING: '进行中',
    STOP: '已终止',
    COMPLETED: '已完成',
  },
  // TaskStatusObjColor: {
  //   NO_START: '#666666',
  //   PROCESSING: '#2DA12B',
  //   UNCOMPLETED: '#e75d58',
  //   OVERTIME: '#FF513D',
  //   DELAYREVIEW: '#e7b953',
  //   END: '#a9a9a9',
  //   COMPLETED: '#999999'
  // },
  // 巡检任务&巡更任务 二级状态
  TaskSecondStatusObj: {
    NO_START: '未开始',
    REVIEWING: '审核中',
    PROCESSING: '进行中',
    UNCOMPLETED: '未完成',
    OVERTIME: '已超时',
    DELAYREVIEW: '延期待审核',
    END: '已结束',
    COMPLETED: '已完成',
    TRANSFER: '已转移',
    CLOSED: '已关闭',
    CANCEL: '已撤销',
    CLEAR: '清除',
  },
  // TaskSecondStatusObjColor: {
  //   NO_START: '#666666',
  //   PROCESSING: '#2DA12B',
  //   UNCOMPLETED: '#e75d58',
  //   OVERTIME: '#FF513D',
  //   DELAYREVIEW: '#e7b953',
  //   END: '#a9a9a9',
  //   COMPLETED: '#999999'
  // },

  PayStatusObj: {
    ONGOING: '进行中',
    UNPAID: '待付款',
    CLOSE: '订单关闭',
    PAID: '交易成功',
    REFUND: '退款成功',
  },
  OrderStatusObj: {
    /**
     * 进行中：待接单
     */
    GOODS_ORDER_WAIT: '待接单',

    /**
     * 进行中：待签署
     */
    GOODS_ORDER_SIGNED: '待签署',

    /**
     * 商家已接单
     */
    GOODS_ORDER_TACK: '待发起签约',

    /**
     * 进行中：合同驳回
     */
    GOODS_ORDER_DISMISS: '合同驳回',

    /**
     * 进行中：合同已过期
     */
    GOODS_ORDER_OVERDUE: '合同已过期',

    /**
     * 进行中：合同待处理
     */
    GOODS_ORDER_HANDLE: '合同待处理',

    /**
     * 待付款：合同已生效
     */
    GOODS_ORDER_EFFECT: '合同已生效',

    /**
     * 待付款：待业主付款
     */
    GOODS_ORDER_PAY_WAIT: '待业主付款',

    /**
     * 待付款：已超时
     */
    GOODS_ORDER_PAY_TIMEOUT: '已超时',

    /**
     * 订单关闭：未付款
     */
    GOODS_ORDER_PAY_NOT: '未付款',

    /**
     * 订单关闭：商家未接单
     */
    GOODS_ORDER_TIMEOUT: '商家未接单',

    /**
     * 订单关闭：商家拒单
     */
    GOODS_ORDER_DOWN: '商家拒单',

    /**
     * 订单关闭：买家取消订单
     */
    GOODS_ORDER_CANCEL: '买家取消订单',

    /**
     * 订单关闭：签约取消
     */
    GOODS_ORDER_SIGNED_CANCEL: '签约取消',

    /**
     * 交易成功：合同生效
     */
    GOODS_ORDER_TO_PACT: '合同生效',

    /**
     * 交易成功：采购申请通过
     */
    GOODS_ORDER_PROCUREMENT: '采购申请通过',

    /**
     * 交易成功：已收款
     */
    GOODS_ORDER_RECEIPT: '已收款',

    /**
     * 退款：待退款
     */
    GOODS_ORDER_REFUND_WAIT: '待退款',

    /**
     * 退款：退款成功
     */
    GOODS_ORDER_REFUND_SUCCESS: '退款成功',

    /**
     * 退款：退款失败
     */
    GOODS_ORDER_REFUND_FAIL: '退款失败',
  },
  // 合同主状态
  MasterStateObj: {
    SIGN_WAIT: '待签署',
    SIGN_OPEN: '已生效',
    SIGN_REJECT: '已驳回',
    SIGN_TIMEOUT: '已过期',
    SIGN_DISCARD: '已废弃',
  },
  // 合同二级状态
  SubStateObj: {
    C_STATELESS: '无状态',
    C_PAAS_APPLY_WAIT: '待平台审核',
    C_BOTH_AGREE: '双方确认签署',
    C_SHOP_REJECT: '服务商驳回合同',
    C_EXPIRATION: '合同已过有效期',
    C_TIMEOUT: '到期未签署',
    C_REVOKE: '合同已解除',
    C_CANCEL: '合同已撤消',
    C_REMOVE: '合同已取消',
  },
  // 审核类别
  ApplyTypeEnumObj: {
    CONTRACT_UNDO: '撤销合同',
    CONTRACT_RELIEVE: '解除合同',
  },
  // 审核状态
  ApplyStatusObj: {
    AUDIT_WAIT: '待审核',
    AUDIT_PASS: '审核通过',
    AUDIT_NOT_PASS: '审核未通过',
    AUDIT_CANCEL: '取消审核',
  },
  // 审核二级状态
  ApplySubStateObj: {
    PARTY_A_UNDO_APPLY: '甲方申请撤销',
    PARTY_A_RELIEVE_APPLY: '甲方申请解除',
    PARTY_A_CANCEL_UNDO: '甲方取消撤销申请',
    PARTY_A_CANCEL_RELIEVE: '甲方取消解除申请',
    PARTY_A_PAAS_APPLY: '甲方申请平台介入',
    PARTY_B_UNDO_APPLY: '乙方申请撤销',
    PARTY_B_RELIEVE_APPLY: '乙方申请解除',
    PARTY_B_CANCEL_UNDO: '甲方取消撤销申请',
    PARTY_B_CANCEL_RELIEVE: '甲方取消解除申请',
    PARTY_B_PAAS_APPLY: '乙方申请平台介入',
    BOTH_UNDO_AGREE: '双方同意撤销',
    BOTH_RELIEVE_AGREE: '双方同意解除',
    PARTY_A_REJECT: '甲方驳回',
    PARTY_B_REJECT: '乙方驳回',
    PAAS_AGREE: '平台通过',
    PAAS_REJECT: '平台驳回',
  },
  // 数据来源
  HouseDataSourceTypeEnum: {
    Platform: '平台录入',
    Synchronization: '住建同步',
    Property: '物业企业',
    Committee: '自治组织',
    Community: '社区街道',
  },
  // 商品列表状态
  SaleStatusObj: {
    OFFSALE: '下架',
    ONSALE: '上架',
    TIMINGSALE: '定时上架',
    SALE_OUT: '售罄',
    ONAUDIT: '审核通过',
    OFFAUDIT: '待审核',
  },
  // 合同详情 applyType
  ApplyTypeObj: {
    CXHT: 'CONTRACT_UNDO',
    JCHT: 'CONTRACT_RELIEVE',
  },
  // 物业类型
  VillageTypeObj: {
    DC: '多层住宅',
    GC: '高层住宅',
    CGC: '超高层住宅',
    BS: '别墅',
    DP: '叠拼',
    ZH: '商业办公楼',
    BG: '公寓',
    GY: '多层住宅',
  },
  // 结算状态
  SettlementStatusObj: {
    SETTLE_WAIT: '待结算',
    SETTLE_ONGOING: '结算中',
    SETTLE_SUCCESS: '结算完成',
  },
  // 支付方式
  PayChannelObj: {
    WECHAT: '微信',
    ALIPAY: '支付宝',
    UNIONPAY: '云闪付',
  },
  // 进度处理
  StateObj: {
    SUBMIT: '已提交',
    ALLOCATED: '已指派',
    RECEIVED: '已接单',
    UNRECEIVED: '未接单',
    DEALING: '处理中',
    DEAL: '已处理',
    TRANSFER: '已转移',
    CANCEL: '已撤销',
    CLOSED: '已关闭',
    NOPASS: '未通过',
    PASS: '通过',
    COMPLETED: '完成',
    WAIT: '待审核',
    WAIT_ALLOCATED: '待指派',
    WAIT_RECEIVED: '待接单',
  },
  // 审核状态
  ReviewStatusObj: {
    WAIT_AUDIT: '待审核',
    PASS_AUDIT: '已通过',
    NOT_PASS_AUDIT: '未通过',
    CANCEL_AUDIT: '已取消',
  },

  AccountStatusObj: {
    NOT_ACCOUNT: '未到账',
    TRANSFER: '进行中',
    HAVE_ACCOUNT: '已到账',
  },
  PlanStatusObj: {
    NO_START: '未开始',
    PROCESSING: '进行中',
    STOP: '已终止',
    // END: '已完成',
    COMPLETE: '已完成',
  },
  WorkOrderStatusObj: {
    NO_START: '未指派',
    REVIEWING: '审核中',
    WAIT_PROCESSING: '待处理',
    PROCESSING: '处理中',
    UNCOMPLETED: '未完成',
    OVERTIME: '已超时',
    DELAYREVIEW: '延期待审核',
    END: '已结束',
    COMPLETED: '已完成',
    TRANSFER: '已转移',
    CLOSED: '已关闭',
    CANCEL: '撤销',
    CLEAR: '清除',
  },
  // 查询条件
  WorkOrderStatusQueryObj: {
    NO_START: '未指派',
    WAIT_PROCESSING: '待处理',
    PROCESSING: '处理中',
    COMPLETED: '已完成',
    CLOSED: '已关闭',
  },
  // 账单管理
  applyStateObj: {
    APPLY_WAIT: '待审核',
    APPLY_PASS: '已通过',
    APPLY_REJECT: '已驳回',
    APPLY_CANCEL: '已撤销',
    APPLY_ONGOING: '审核中',
  },
  // 账单生产记录
  BillGenerationMethodObj: {
    SYSTEM: '系统',
    BOOK: '手工记账',
    PURCHASE: '采购记账',
  },
  // 身份
  IdentityObj: {
    HZ: '户主',
    YZ: '业主',
    ZK: '租客',
    CLAN: '亲属',
    CLAN_PARENTS: '父母',
    CLAN_SON: '子女',
    CLAN_GRANDSON: '孙/外孙',
    CLAN_MATE: '配偶',
    CLAN_OTHER: '其他',
  },
  // 新增里的关系
  RelationObj: {
    CLAN_PARENTS: '父母',
    CLAN_MATE: '配偶',
    CLAN_FATHER: '父',
    CLAN_MOTHER: '母',
    CLAN_SON: '子/婿',
    CLAN_DAUGHTER: '女/媳',
    CLAN_GRANDDAUGHTER: '孙女/外孙女',
    CLAN_GRANDSON: '孙/外孙',
    CLAN_GRANDFATHER: '祖父/外祖父',
    CLAN_GRANDMOTHER: '祖母/外祖母',
    CLAN_BROTHER: '兄/弟',
    CLAN_SISTER: '姐/妹',
    CLAN_OTHER: '其他',
  },
  // 亲属
  relativesObj: {
    CLAN_PARENTS: '父母',
    CLAN_MATE: '配偶',
    CLAN_FATHER: '父',
    CLAN_MOTHER: '母',
    CLAN_SON: '子/婿',
    CLAN_DAUGHTER: '女/媳',
    CLAN_GRANDDAUGHTER: '孙女/外孙女',
    CLAN_GRANDSON: '孙/外孙',
    CLAN_GRANDFATHER: '祖父/外祖父',
    CLAN_GRANDMOTHER: '祖母/外祖母',
    CLAN_BROTHER: '兄/弟',
    CLAN_SISTER: '姐/妹',
    CLAN_OTHER: '其他',
  },
  // 业主审核
  StateTypeObj: {
    /**
     * 待审核
     */
    DSH: '待审核',
    /**
     * 已通过
     */
    YTG: '已通过',
    /**
     * 未通过
     */
    WTG: '未通过',
    /**
     * 已撤销
     */
    YCX: '已撤销',
  },
  // 支付方式
  PayChannelEnum: {
    /**
     * 微信
     */
    WECHAT: '微信',
    /**
     * 支付宝
     */
    ALIPAY: '支付宝',
    /**
     * 现金
     */
    CASH: '现金',
    /**
     * 云闪付
     */
    // UNIONPAY: '云闪付',
    /**
     * 线下支付
     */
    // OFFLINE: '线下支付'
    /**
     * 银行卡
     */
    BANK_CARD: '银行卡',
  },
  // 支付平台
  PaymentMethod: {
    /**
     * 线下支付
     */
    OFFLINE: '线下支付',

    /**
     * APP
     */
    APP: 'APP',

    /**
     * 小程序
     */
    MINI_APP: '小程序',
  },
  /*
   * 建议状态
   * */
  AdviceStatus: {
    ADVICE_WAIT: '待处理',
    ADVICE_SUCCESS: '已完成',
  },
  // 事件类型
  MajorEventTypeEnum: {
    /**
     * 火灾
     */
    FIRE: '火灾',
    /**
     * 电梯困人
     */
    ELEVATOR_FAILURE: '电梯困人',
    /**
     * 爆炸
     */
    BLAST: '爆炸',
    /**
     * 突发性停电
     */
    POWER_CUT: '突发性停电',
    /**
     * 水浸
     */
    WETTING: '水浸',
    /**
     * 盗窃
     */
    THEFT: '盗窃',
    /**
     * 械斗
     */
    FIGHTING: '械斗',
    /**
     * 刑事案件
     */
    CRIMINAL_CASE: '刑事案件',
    /**
     * 用户集体投诉
     */
    GROUP_COMPLAINTS: '用户集体投诉',
    /**
     * 设备故障
     */
    DEVICE_FAILURE: '设备故障',
    /**
     * 主体结构遭受破坏
     */
    MAIN_STRUCTURE_DAMAGED: '主体结构遭受破坏',
    /**
     * 其他
     */
    OTHER: '其他',
  },
  // 学历
  EducationTypeEnum: {
    /**
     * 高中及以下
     * */
    HIGH_SCHOOL_AND_BELOW: '高中及以下',
    /**
     * 大专
     */
    COLLEGE: '大专',
    /**
     * 本科
     */
    UNDERGRADUATE: '本科',
    /**
     * 研究生及以上
     */
    POSTGRADUATE_AND_ABOVE: '研究生及以上',
  },

  // 政治面貌
  PoliticsStatusEnum: {
    /**
     * 党员
     */
    PARTY_MEMBER: '党员',

    /**
     * 预备党员
     */
    PROBATIONARY_PARTY_MEMBER: '预备党员',

    /**
     * 共青团员
     */
    LEAGUE_MEMBER: '共青团员',

    /**
     * 民革党员
     */
    MDC_PARTY: '民革党员',

    /**
     * 民盟盟员
     */
    PAD_LEAGUER: '民盟盟员',

    /**
     * 民建会员
     */
    COMMITTEE_MEMBER: '民建会员',

    /**
     * 民进会员
     */
    DPP_MEMBERS: '民进会员',

    /**
     * 农工党党员
     */
    FARMER_LABOUR: '农工党党员',

    /**
     * 致公党党员
     */
    ZHI_GONG_PARTY: '致公党党员',

    /**
     * 九三学社社员
     */
    JIU_SAN_SOCIETY: '九三学社社员',

    /**
     * 台盟盟员
     */
    TAI_MENG_LEAGUER: '台盟盟员',

    /**
     * 无党派人士
     */
    NON_PARTY: '无党派人士',

    /**
     * 群众
     */
    THE_MASSES: '群众',
  },

  // 业委会换届状态
  OwnerCommitteeStateEnum: {
    /**
     * 审批中
     */
    COMMITTEE_BEING: '待审批',
    /**
     * 通过
     */
    COMMITTEE_PASSED: '已通过',
    /**
     * 驳回
     */
    COMMITTEE_REJECT: '已驳回',
    /**
     * 失效
     */
    COMMITTEE_INVALID: '已失效',
    /**
     * 撤销
     */
    COMMITTEE_CANCEL: '已撤销',
  },
  // 接受对象
  PublicNoticeAimTypeEnum: {
    /**
     * 服务人员
     */
    COMPANY: '服务人员',
    /**
     * 业主委员会成员
     */
    ASSEMBLY: '业主委员会成员',
    /**
     * 业主
     */
    HOUSE_OWNER: '业主',
    /**
     * 住建厅
     */
    BUILD_DEPT: '住建厅',
    /**
     * 街道办事处
     */
    STREET_OFFICE: '街道办事处',
    /**
     * 社区居委会
     */
    COMMUNITY: '社区居委会',
  },
  // 行业端消息枚举
  MessageTypeEnum: {
    /**
     * 系统通知
     */
    SYSTEM: '系统通知',
    /**
     * 订单通知
     */
    ORDER: '订单通知',
    /**
     * 小区通知
     */
    VILLAGE: '小区通知',
    /**
     * 任务通知
     */
    TASK: '任务通知',
    /**
     * 通知公告
     */
    NOTICE: '通知公告',
  },
  RentStatusEnum: { // 房屋租赁状态
    NOT_RENTED: '未租赁',
    RENTED: '租赁',
  },
  StayStatusEnum: { // 房屋使用状态
    IS_STAY: '已入住',
    IS_NOT_STAY: '未入住',
  },
  BuildingTypeEnum: { // 楼栋性质
    RESIDENTIAL: '住宅',
    NON_RESIDENTIAL: '非住宅',
  },
};
